<tec-modal
	[isVisible]="true"
	[title]="title"
	[buttonPrimaryLabel]="buttonPrimaryLabel"
	[buttonSecondaryLabel]="isReadOnly ? undefined : ('BUTTON.CANCEL' | translate)"
	(closeEvent)="closeModal($event)"
>
	<ng-container body [formGroup]="form">
		@if (errorMsg) {
			<tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''"></tec-alert>
		}

		<div class="modal-form-step-body">
			@if (isReadOnly) {
				<app-form-step-readonly-view [form]="form" />
			} @else {
				<tec-stepper-micro [steps]="steps" (clickEvent)="clickStep($event)"></tec-stepper-micro>

				@if (steps.at(0)?.selected) {
					<app-form-step-type-picker
						[fieldPresets]="fieldPresets"
						[selectedPresetId]="selectedPresetId"
						(presetSelected)="selectPreset($event)"
					/>
				}

				@if (steps.at(1)?.selected) {
					<tec-tile
						[title]="selectedPreset?.labelKey ? (selectedPreset.labelKey | translate) : ('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.FIELDS_TITLE' | translate)"
						icon="icon-capture-popup"
					>
						<ng-container actions>
							<tec-link [label]="'BUTTON.EDIT' | translate" (click)="editType()" />
						</ng-container>

						@if (isFieldMetadataLocked && selectedPreset) {
							<app-form-step-locked-preset-config [form]="form" [preset]="selectedPreset" />
						} @else {
							<app-form-step-editable-preset-config
								[form]="form"
								[fieldsArray]="fieldsArray"
								[preset]="selectedPreset"
								[primaryField]="primaryField"
							/>
						}
					</tec-tile>

					@if (primaryField) {
						<app-form-step-advanced-config
							[required]="isFieldRequired()"
							[requiredLocked]="isRequiredLocked"
							[showMatchOcr]="supportsMatchOcrConfig"
							[matchOcrEnabled]="matchOcrEnabled()"
							[matchOcrLocked]="isMatchOcrLocked"
							(requiredChange)="setFieldRequired($event)"
							(matchOcrChange)="onMatchOcrChange($event)"
						/>
					}
				}
			}
		</div>
	</ng-container>
</tec-modal>
